module.exports = "<div class=\"container\">\n  <form>\n    <label>添加数据</label>\n    <div class=\"form-group\">\n      <label for=\"file\">文件 <span class=\"text-danger\">(必需)</span></label>\n      <input type=\"file\" ngf-select ng-model=\"kbAddCtrl.kbFile\" name=\"file\" required ngf-model-invalid=\"errorFile\"\n        class=\"form-control\">\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-success\" ng-click=\"kbAddCtrl.addData(kbAddCtrl.kbFile)\">保存</button>\n  </form>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/keyboard/add/add.html
// module id = 534
// module chunks = 0